var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"hide-footer":"","size":"lg","title":"Procesamiento de importacion","id":"article-import-observations"}},[_c('b-table',{attrs:{"head-variant":"dark","fields":_vm.fields,"items":_vm.items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }